import { Component, OnInit } from '@angular/core';
import { ContractService } from '../../_services';
import { ContractBase } from "./contract.base";

@Component({
    selector: 'contract-assignment-subletting',
    template: require('./contract-assignment-subletting.template.html')
})
export class ContractAssignmentSublettingComponent extends ContractBase implements OnInit {

    constructor(
        protected readonly contractService: ContractService) {
        super(contractService);
    }
    
    get assignmentAndSubletting(): any {
        const contract: any = this.contract;
        return contract != null ? contract.assignmentAndSubletting : null;
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
    }


}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/contract-assignment-subletting.component.ts